import {disPlayListOfServices} from "./disPlayListOfServices";
import {fullAddressRoundRobinApi} from "./fullAddressRoundRobinApi"
import {addressBumper} from "./addressBumper";
export function findHelpAddressBumper(zipcode:any){
    addressBumper.addressBumperFlag = true;
    $('.address-bumper-screen input[name="inputZipCode1"]').val(zipcode);
    $('.address-bumper-screen .next').click(function(){
        $('.scheduler-modal .modal-content').addClass('banner-wizard');
        var address = $('.address-bumper-screen input[name="inputAddressBumper"]').val();
        var apartment = $('.address-bumper-screen input[name="inputAddressBumper2"]').val();
        var city = $('.address-bumper-screen input[name="inputcity1"]').val();
        var state = $('.address-bumper-screen select[name="inputstate1"]').val();
        var zipCode:any = $('.address-bumper-screen input[name="inputZipCode1"]').val();
        apartment = apartment ? apartment + " ": "";
        var addressParam = address + " " + apartment +city + " " + state + " " + zipCode;
        // var addressParam = address + "&" + apartment + "&" + city + "&" + state + "&" + zipCode;
        window.objOSGlobal.requestBodyValues.PostalCode = zipCode;
        localStorage.setItem('zipcode',zipCode);
        fullAddressRoundRobinApi(addressParam,true,()=>{
            disPlayListOfServices(zipCode);
        },'');
    });
}